import {initElements} from "../define/shared";

export default function initHeader() {
    initElements(".siteHeader", header => {
        const menuBtn = header.querySelector(".siteHeader-menuBtn");
        const menu = header.querySelector(".siteHeader-menu");
        const links = menu ? [].slice.apply(menu.querySelectorAll("a")) : [];
        const openLoginModal = header.querySelector(".openLoginModal");
        const loginForm = header.querySelector(".siteHeader-loginForm");
        const closeLoginModal = loginForm.querySelector(".icon-close");
        const loader = loginForm.querySelector(".loader");
        const goToAccBtn = document.querySelector(".legal-question .openLoginForm");
        const url = new URL(window.location.href);
        const myAccMenu = document.querySelector(".myAccount-side");
        const search = header.querySelector(".siteHeader-search");
        const searchIcon = header.querySelector(".searchIcon");

        if (!menuBtn) {
            return;
        }

        window.addEventListener("scroll", () => {
            window.pageYOffset > 0 ? header.classList.add("onscroll") : header.classList.remove("onscroll");
        });

        menuBtn.addEventListener("click", () => {
            menuBtn.classList.toggle("is-active");
            menu.classList.toggle("is--open");
        });

        links.forEach((link, index) => {
            link.style = `transition-delay: ${index * 50}ms`;
            link.addEventListener("click", event => {
                menuBtn.classList.remove("is-active");
                menu.classList.remove("is--open");
            });
        });

        if (openLoginModal) {
            openLoginModal.addEventListener("click", () => {
                loginForm.classList.add("is--open");
            });
        }

        closeLoginModal.addEventListener("click", () => {
            loginForm.classList.remove("is--open");
        });

        if (goToAccBtn) {
            goToAccBtn.addEventListener("click", e => {
                e.preventDefault();
                loginForm.classList.add("is--open");
            });
        }

        if (url.searchParams.has("login")) {
            loginForm.classList.add("is--open");
        }

        loginForm.querySelector("form").addEventListener("submit", (e) => {
            e.preventDefault();
            loader.classList.add("is--active");
            loginForm.classList.add("is--loading");
            const errorMessageEl = loginForm.querySelector(".errorMessage");
            errorMessageEl.innerHTML = "";

            fetch(window.RES.base + "wa-theme/v1/user-login", {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                },
                body: JSON.stringify({
                    email: loginForm.querySelector("[name=\"log\"]").value,
                    password: loginForm.querySelector("[name=\"pwd\"]").value,
                })
            }).then(response => response.json())
                .then(res => {
                    loader.classList.remove("is--active");
                    loginForm.classList.remove("is--loading");
                    if (res.success) {
                        window.location.href = loginForm.dataset.redirectUrl;
                    } else {
                        errorMessageEl.innerHTML = res.error;
                    }
                });
        });

        document.querySelectorAll("a").forEach(a => {
            a.addEventListener("click", event => {
                const url = new URL(a.href);
                if (url.searchParams.has("login")) {
                    event.preventDefault();
                    loginForm.classList.add("is--open");
                }
            });
        });

        loginForm.querySelector(".createAccount").addEventListener("click", initCreateAccount);

        if (myAccMenu) {
            const closeBtn = myAccMenu.querySelector(".icon-close");
            const openBtn = document.querySelector(".openMyAccMenu");

            if (!openBtn) {
                return;
            }

            openBtn.addEventListener("click", () => {
                myAccMenu.classList.add("is--open");
            });

            closeBtn.addEventListener("click", () => {
                myAccMenu.classList.remove("is--open");
            });

            document.addEventListener("click", (e) => {
                if (e.target !== openBtn) {
                    myAccMenu.classList.remove("is--open");
                }
            });
        }

        searchIcon.addEventListener("click", function () {
            search.classList.toggle('is--open')
            search.querySelector('input').focus()
        });

        function initCreateAccount() {
            const loginFields = loginForm.querySelector(".loginFields");
            const createAccFields = loginForm.querySelector(".createAccFields");
            const createAccSuccess = loginForm.querySelector(".createAccSuccess");
            const goBack = createAccFields.querySelector(".backToLogin");
            const loginBtn = loginForm.querySelector(".loginBtn");
            const createAccBtn = createAccFields.querySelector("#createAccount");
            const errorMessageEl = createAccFields.querySelector(".errorMessage");
            const policy = createAccFields.querySelector("[name=\"policy\"]");

            const fields = {
                name: createAccFields.querySelector("[name=\"name\"]"),
                surname: createAccFields.querySelector("[name=\"surname\"]"),
                email: createAccFields.querySelector("[name=\"email\"]"),
                phone: createAccFields.querySelector("[name=\"phone\"]"),
            };

            loginFields.style.display = "none";
            createAccFields.style.display = "block";

            goBack.addEventListener("click", () => {
                loginFields.style.display = "block";
                createAccFields.style.display = "none";
            });

            loginBtn.addEventListener("click", () => {
                loginFields.style.display = "block";
                createAccSuccess.style.display = "none";
            });

            policy.addEventListener("change", () => {
                policy.checked ? createAccBtn.removeAttribute("disabled") : createAccBtn.setAttribute("disabled", "");
            });

            createAccBtn.addEventListener("click", () => {
                errorMessageEl.innerHTML = "";

                if (!fields.name.value) {
                    errorMessageEl.innerHTML = "Förnamn är obligatoriskt fält.";
                } else if (!fields.email.value) {
                    errorMessageEl.innerHTML = "E-post är obligatoriskt fält.";
                }

                if (fields.name.value && fields.email.value) {
                    loader.classList.add("is--active");
                    loginForm.classList.add("is--loading");
                    errorMessageEl.innerHTML = "";

                    fetch(window.RES.base + "wa-theme/v1/user-create-account", {
                        method: "POST",
                        headers: {
                            "Content-type": "application/json",
                        },
                        body: JSON.stringify({
                            data: {
                                name: fields.name.value,
                                surname: fields.surname.value,
                                email: fields.email.value,
                                phone: fields.phone.value,
                            }
                        })
                    }).then(response => response.json())
                        .then(res => {
                            loader.classList.remove("is--active");
                            loginForm.classList.remove("is--loading");
                            if (res.success) {
                                createAccFields.style.display = "none";
                                createAccSuccess.style.display = "block";
                            } else {
                                errorMessageEl.innerHTML = res.error;
                            }
                        });
                }
            });
        }
    });
}
